module.exports = __webpack_public_path__ + "img/dispose15.f738d8b4.png";